import { css } from "theme/default/css";

export const setFlexDFAICJCSB = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
